import React from 'react';
import './TopBar.scss';

import { Icon } from '../../atoms/Icon/Icon';

export const TopBar = (props) => {
  const { } = props;
  return (
    <div className='top-bar'>
      <div className='icon-container' onClick={() => { window.location.href = "https://www.constlending.com"; }}>
        <Icon svgFilePath={"./assets/icons/constlending-logo.svg"} />
      </div>
      <div className='right-container'>
        <div className="question">
          <span className="question-text">Text or call us at</span>
          <span className="phone-number">(203) 423-3534</span>
        </div>
      </div>
    </div>
  );
}
